import {createAction} from '@ngrx/store';

export const resetStore = createAction(
    '[Tickist] Clear All data from store'
)

